module.exports = __webpack_public_path__ + "media/stylesheets/images/register_coupon_register-bbd52480916690c98ebdb20885707393.png";